export default __webpack_public_path__ + "static/media/logo-rouanet.e15ac5aa.svg";